import { atom } from "jotai";

export const backendDataAtom = atom({ type: "none", data: undefined, id: undefined });
